<template>
    <div v-show="isActive">
        <slot />
    </div>
</template>

<script>
import { computed, inject, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue';

export default {
    name: 'EStepItem',
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        clickable: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const registerStep = inject('registerStep', null);
        const unregisterStep = inject('unregisterStep', null);
        const activeStepIndex = inject('activeStepIndex', ref(0));

        const stepData = reactive({
            uid: Math.random().toString(36).substring(2, 9),
            label: props.label,
            icon: props.icon,
            clickable: props.clickable,
            disabled: props.disabled,
            visible: props.visible,
        });

        watch(
            () => props.label,
            val => (stepData.label = val)
        );
        watch(
            () => props.icon,
            val => (stepData.icon = val)
        );
        watch(
            () => props.clickable,
            val => (stepData.clickable = val)
        );
        watch(
            () => props.disabled,
            val => (stepData.disabled = val)
        );
        watch(
            () => props.visible,
            val => (stepData.visible = val)
        );

        onMounted(() => {
            if (registerStep) {
                registerStep(stepData);
            }
        });

        onBeforeUnmount(() => {
            if (unregisterStep) {
                unregisterStep(stepData);
            }
        });

        const steps = inject('steps', ref([]));

        const isActive = computed(() => {
            const visibleIndex = steps.value.filter(s => s.visible).indexOf(stepData);
            return visibleIndex === activeStepIndex.value;
        });

        return {
            isActive,
        };
    },
};
</script>
